export const displayName = (firstName, lastName) => `${firstName || ''}${(firstName && ' ') || ''}${lastName || ''}`;
